import Vue from 'vue'
import settingsApi from '@/api/settings.api'


const state = {
  settings: {}
}


const getters = {
  currentSettings: (state, getters, rootState) => {
    return state.settings[rootState.tenant.current] || {
      currency: 'NOK'
    }
  }
}


const actions = {
  async loadSettings ({ commit, rootState }) {
    const response = await settingsApi.getSettings(rootState.tenant.current)
    commit('SET_SETTINGS', { tenant: rootState.tenant.current, settings: response.data })
    return response.data
  },

  async updateSettings ({ commit, rootState }, settings) {
    const response = await settingsApi.updateSettings(rootState.tenant.current, settings)
    commit('SET_SETTINGS', { tenant: rootState.tenant.current, settings: response.data })
    return response.data
  }
}


const mutations = {
  SET_SETTINGS (state, { tenant, settings }) {
    Vue.set(state.settings, tenant, settings)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
